import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es.array.concat.js";
var BASE_TEAM_KEY = 'team';
var teamKeys = {
  allTeams: function allTeams() {
    return [BASE_TEAM_KEY];
  },
  teams: function teams(query) {
    return [BASE_TEAM_KEY, query];
  },
  teamTypes: [BASE_TEAM_KEY, 'types'],
  teamsById: function teamsById(ids) {
    return [BASE_TEAM_KEY, 'selected'].concat(_toConsumableArray(ids));
  }
};
export default teamKeys;